<template>
  <div class="text-center d-flex justify-center align-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="250"
      bottom
      :offset-y="true"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-avatar
          size="35"
          v-bind="attrs"
          v-on="on"
          class="profile-avatar"
          :color="!profilePictureUrl ? 'success' : undefined"
        >
          <img v-if="profilePictureUrl" :src="profilePictureUrl" alt="User" />
          <v-icon v-else size="17" color="white">
            {{ genderIcon }}
          </v-icon>
        </v-avatar>
      </template>

      <v-card elevation="0" class="shadow">
        <v-list>
          <v-list-item-title
            class="font-weight-bold text-secondary fs-6 pt-3 pb-2 px-3"
          >
            {{ $t("account") }}
          </v-list-item-title>
          <v-list-item>
            <v-list-item-avatar
              :color="!profilePictureUrl ? 'success' : undefined"
            >
              <img
                v-if="profilePictureUrl"
                :src="profilePictureUrl"
                alt="User"
              />
              <v-icon v-else color="white">
                {{ genderIcon }}
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="d-flex align-center gap-2"
                >{{ fullName }}
                <v-chip
                  v-if="userType"
                  class="user-type-chip"
                  color="success"
                  text-color="white"
                >
                  {{ userType }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle>{{ userEmail }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider class="my-0"></v-divider>

        <v-list class="py-0">
          <v-list-item
            v-for="menuLink in headerMenuItems"
            :key="menuLink.id"
            @click="navigateToMenu(menuLink.componentName)"
          >
            <v-list-item-title>
              {{ $t("header." + menuLink.name) }}
            </v-list-item-title>
          </v-list-item>
        </v-list>

        <v-divider class="my-0"></v-divider>

        <v-list class="py-0">
          <v-list-item class="logout-item">
            <v-list-item-title class="error--text">
              <Logout />
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { header } from "@/data/header.js"
import { mapGetters } from "vuex"
import Logout from "@/components/Logout.vue"

export default {
  name: "ProfileMenu",
  components: {
    Logout,
  },
  data: () => ({
    menu: false,
    fav: true,
    message: false,
    hints: true,
  }),
  computed: {
    ...mapGetters("filters", ["filters"]),
    ...mapGetters("courses", {
      courses: "getCourses",
    }),
    fullName() {
      return `${this.$store.getters.StateUser.user.first_name} ${this.$store.getters.StateUser.user.last_name}`
    },
    userEmail() {
      return this.$store.getters.StateUser.user.email
    },
    profilePictureUrl() {
      return this.$store.getters.StateUser.user.profile_picture_url
    },
    userType() {
      return this.$store.getters.StateUser.user.user_type.includes("admin")
        ? "Admin"
        : this.$store.getters.StateUser.user.user_type
    },
    genderIcon() {
      const user = this.$store.getters.StateUser.user
      if (user && user.gender && user.gender.toLowerCase() === "male") {
        return "mdi-account-tie"
      } else if (
        user &&
        user.gender &&
        user.gender.toLowerCase() === "female"
      ) {
        return "mdi-account-heart"
      } else {
        return "mdi-account"
      }
    },
    headerMenuItems() {
      const userType = this.$store.getters.StateUser.user.user_type.includes(
        "student"
      )
        ? "student"
        : this.$store.getters.StateUser.user.user_type

      return (
        header(this.courseTypes, this.instituteName, this.courses).header_menu[
          userType
        ] || []
      )
    },
    courseTypes() {
      return this.filters.find(
        filter => filter.api_param_name === "course_types"
      )
    },
    instituteName() {
      return this.$store.getters.StateUser.user.institute_name
    },
  },
  methods: {
    navigateToMenu(componentName) {
      // Check if we're already on the target route to prevent navigation error
      if (this.$route.name === componentName) {
        this.menu = false
        return
      }

      this.$router.push({ name: componentName })
      this.menu = false
    },
  },
}
</script>

<style lang="scss" scoped>
.profile-avatar {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 3px solid transparent;
  position: relative;
  margin: 2px;

  &:hover {
    border-color: #fafafa;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
    border-color: #1565c0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  &.v-menu__activator--active {
    border-color: #1976d2;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
  }
}

// Ensure menu appears below avatar
::v-deep .v-menu__content {
  margin-top: 1rem !important;
  z-index: 9999 !important;
}

// Simple hover effect for menu items
::v-deep .v-list-item {
  /* transition: all 0.3s ease; */
  border: 1px solid transparent;

  &:hover {
    background-color: #f5f5f5 !important;
    border-color: rgba(102, 126, 234, 0.1);
    .v-list-item__title {
      /* transform: translateX(8px); */
    }
  }

  .v-list-item__title {
    /* transition: all 0.3s ease; */
  }
}

// Hover effect for logout item
::v-deep .logout-item {
  cursor: pointer;
  &:hover {
    background-color: #ffebee !important;
  }
}

.user-type-chip {
  font-size: 11px;
  font-weight: 600;
  height: 22px !important;
  background: linear-gradient(135deg, #4caf50, #81c784) !important;
  color: white !important;
  border: none !important;
}
</style>
